import { toast } from "react-toastify";

const escapeHtml = (value: string) => value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

// Fills {{key}} placeholders with HTML-escaped values. Unknown placeholders become "-".
const fillTemplate = (html: string, values: Record<string, string>) =>
    html.replace(/{{\s*(\w+)\s*}}/g, (_match, key: string) => escapeHtml(values[key] ?? "-"));

// Fetches an HTML template from public/templates and fills it. Returns null (and toasts) on failure.
export const renderTemplate = async (templateName: string, values: Record<string, string>): Promise<string | null> => {
    try {
        const res = await fetch(`${process.env.PUBLIC_URL}/templates/${templateName}`);
        if (!res.ok) throw new Error("Print template not found.");
        return fillTemplate(await res.text(), values);
    } catch (err: any) {
        toast.error(err.message ?? "Error loading print template");
        return null;
    }
};
